import React, { useState } from 'react';

export interface SideBarItemProps {
  iconLeft: React.ReactNode;
  iconRight?: React.ReactNode;
  text: string;
  selected: boolean;
  collapsed: boolean;
  onClick?: (event: any) => void;
  className?: string;
  contentClassName?: string;
  textClassName?: string;
}

export const SideBarItem: React.FC<SideBarItemProps> = ({
  iconLeft,
  iconRight,
  text,
  selected,
  collapsed,
  onClick,
  className,
  contentClassName,
  textClassName,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={`w-full h-10 flex items-center justify-center gap-2 cursor-pointer rounded-lg bg-brand-white outline ${selected ? 'outline-4 outline-taskonioGreen-200' : isHovered ? 'outline-1 outline-taskonioGreen-200' : 'outline-none'} ${isHovered ? 'bg-taskonioGreen-100' : ''} ${collapsed ? '' : 'px-3.5'} ${className}`}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className={`${contentClassName || 'w-6 h-6'} flex items-center justify-center`}>{iconLeft}</div>
      {!collapsed && (
        <div
          className={`text-brand-grey-dark text-sm flex-1 overflow-hidden text-ellipsis whitespace-nowrap ${textClassName || 'font-semibold'}`}
        >
          {text}
        </div>
      )}
      {!collapsed && iconRight}
    </div>
  );
};

export default SideBarItem;
